import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';

import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import {dateStr, dateAndTime} from '../utils/TimeFormatter';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RC from '../utils/ReactiveClock';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import EditCustomer from '../components/EditCustomer';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';


let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

const formStyle = {
  marginLeft: 16
};

export default
@observer class NewContractPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  cancelUpdate() {
    AppModel.contractForm.reset();
    this.context.router.goBack();
  }

  performUpdate() {
    let contract = AppModel.contractForm.contract;
    let machine = AppModel.contractForm.machine;
    let customer = AppModel.contractForm.customer;
    contract.id_machine = machine.id;
    contract.id_customer = customer.id;
    return AppModelUtils.insertContract(contract)
    .then(()=> {
      // Make sure list of contracts are reloaded to be updated :
      AppModel.contractList = [];
      this.context.router.push(
        `/machine_admin/contracts/${encodeURI(machine.id_customer)}/${encodeURI(machine.id)}`
      )
      return null;
    })
    .catch(()=> {
      console.log("Contract registered.");
    });
  }

  handleNewDate(contract, field) {
    return function(nope, newDate) {
      // TODO : Remove this workaround when material-ui data picker stops
      // returning the wrong date from the picker.
      newDate = new Date(+newDate-newDate.getTimezoneOffset()*60*1000)
      contract[field]=newDate;
    }
  }
  handleUpdate(contract, field) {
    return function(event, key, payload ) {
      contract[field]=payload;
    }
  }
  render() {
    let form = AppModel.contractForm;
    let customer = form.customer;
    let machine = form.machine;
    let contract = form.contract;
    return (
      <div style={pageStyle}>
        <PageLoading loading={
               AppModel.fetchingContractFormContext
            || AppModel.contractDetailLoading
            || AppModel.updatingContractData
          }>
          <h2 style={headerStyle}>{uiMsg('NC_NEW_CONTRACT_FOR',"New contract for:")}</h2>
          <Table>
            <TableBody displayRowCheckbox={false}>
              <TableRow> <TableRowColumn>{uiMsg('CUSTOMER')}</TableRowColumn>
                <TableRowColumn>{customer.name}</TableRowColumn></TableRow>
              <TableRow> <TableRowColumn>{uiMsg('MACHINE')}</TableRowColumn>
                <TableRowColumn>{machine.name}</TableRowColumn></TableRow>
            </TableBody>
          </Table>

        <SelectField
            floatingLabelText={uiMsg('NC_CONTRACT_TYPE',"Contract type")}
            hintText={uiMsg('NC_CONTRACT_TYPE_HINT',"select type of contract")}
            value={contract.type}
            fullWidth={true}
            onChange={this.handleUpdate(contract,"type").bind(this)}>
            <MenuItem key={'Buy'}
                      value={'Buy'}
                      primaryText={uiMsg('NC_MACHINE_BUY','Purchase contract')}
              />
            <MenuItem key={'Hire'}
                      value={'Hire'}
                      primaryText={uiMsg('NC_MACHINE_RENTAL','Rental agreement')}
              />
            <MenuItem key={'Support'}
                      value={'Support'}
                      primaryText={uiMsg('NC_MACHINE_SUPPORT','Support agreement')}
              />
            <MenuItem key={'Prevent'}
                      value={'Prevent'}
                      primaryText={uiMsg('NC_PREVENT','Prevent')}
            />
            <MenuItem key={'Pilot'}
                      value={'Pilot'}
                      primaryText={uiMsg('NC_PILOT','Pilot')}
            />
            <MenuItem key={'Prevent Owner'}
                  value={'Prevent Owner'}
                  primaryText={uiMsg('NC_PREVENT_OWNER','Prevent Owner')}
            />
        </SelectField>
        {contract.type == 'Buy' || contract.type == 'Hire' || contract.type == 'Pilot' ?
          <DatePicker
              floatingLabelText={uiMsg('NC_DELIVERY_DATE',"Delivery date")}
              hintText={uiMsg('NC_DELIVERY_DATE_HINT',"When will the machine be delivered")}
              value = {contract.delivery}
              onChange = {this.handleNewDate(contract,"delivery").bind(this)}/>
            : null
        }
        {contract.type == 'Prevent' ?
          <DatePicker
              floatingLabelText={uiMsg('NC_DELIVERY_DATE',"Delivery date")}
              hintText={uiMsg('NC_DELIVERY_DATE_HINT',"When will the machine be delivered")}
              value = {contract.delivery}
              onChange = {this.handleNewDate(contract,"delivery").bind(this)}/>
            : null
        }
        {contract.type == 'Hire' || contract.type == 'Pilot' ?
          <DatePicker
              floatingLabelText={uiMsg('NC_CONTRACT_END_DATE',"Contract end date")}
              hintText={uiMsg('NC_CONTRACT_END_DATE_HINT',"End of hire period")}
              value = {contract.end_of_contract}
              onChange = {this.handleNewDate(contract,"end_of_contract").bind(this)}/>
            : null }
        {contract.type == 'Support' ?
          <DatePicker
              floatingLabelText={uiMsg('NC_SUPPORT_START_DATE',"Support contract start date")}
              hintText={uiMsg('NC_SUPPORT_START_DATE_HINT',"The date the support contract starts")}
              value = {contract.delivery}
              onChange = {this.handleNewDate(contract,"delivery").bind(this)}/>
            : null
        }        
        {contract.type == 'Prevent Owner' ?
          <DatePicker
              floatingLabelText={uiMsg('NC_START_DATE',"Contract start date")}
              hintText={uiMsg('NC_START_DATE_HINT',"The date the contract starts")}
              value = {contract.delivery}
              onChange = {this.handleNewDate(contract,"delivery").bind(this)}/>
            : null
        }
        {contract.type == 'Support' ?
          <DatePicker
              floatingLabelText={uiMsg('NC_SUPPORT_PAID_TILL',"Support paid till")}
              hintText={uiMsg('NC_SUPPORT_PAID_TILL_HINT',"End of support period")}
              value = {contract.support_paid_till}
              onChange = {this.handleNewDate(contract,"support_paid_till").bind(this)}/>
            : null
          }
          <Toolbar>
            <ToolbarGroup firstChild={true}></ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <FlatButton
                      onTouchTap={this.cancelUpdate.bind(this)}>{uiMsg('NC_CANCEL',"Cancel")}
              </FlatButton>
              <RaisedButton primary
                            disabled = {!contract.validInsert}
                            onTouchTap={this.performUpdate.bind(this)}>
                            {uiMsg('NC_INSERT',"Insert")}
              </RaisedButton>
            </ToolbarGroup>
          </Toolbar>
          {/* added some space at the bottom to allow some scrolling */}
          <div style={{height:"3em"}}></div>
        </PageLoading>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/NewContractPage.jsx
 **/